(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3ClubStats', {
            templateUrl: 'app/club-admin/club-info/club-stats/club-stats.component.html',
            controller: ClubStatsComponent,
            bindings: { club: '<' }
        });

    var extend = angular.extend,
        merge = angular.merge,
        noop = angular.noop;

    ClubStatsComponent.$inject = ['$scope', 'Club', 'membershipCreditModal', 'pieChartDefaultOptions', 'totalAccountsChartDefaults', 'membershipLevelChartDefaults', 'membershipStatusChartDefaults', 'gettextCatalog', 'creditAdjustmentModal', 'user', 'alert', 'clubAdminResources', 'categoriesChartDefaults', 'membershipByCategoryModal', 'compliantClubModal', 'DataSource'];
    function ClubStatsComponent($scope, Club, membershipCreditModal, pieChartDefaultOptions, totalAccountsChartDefaults, membershipLevelChartDefaults, membershipStatusChartDefaults, gettextCatalog, creditAdjustmentModal, user, alert, resources, categoriesChartDefaults, membershipByCategoryModal, compliantClubModal, DataSource) {
        // Variables
        var ctrl = this;

        // Properties
        ctrl.isNationalAdmin = user.isNationalAdmin;
        ctrl.isAssociationAdmin = user.isAssociationAdmin;
        ctrl.dataSource = null;

        // Methods
        ctrl.$onInit = init;
        ctrl.showMembershipCreditModal = membershipCreditModal;
        ctrl.showCreditAdjustmentModal = showCreditAdjustmentModal;
        ctrl.showMembershipByCategoryModal = showMembershipByCategoryModal;
        ctrl.showCompliantClubModal = showCompliantClubModal;

        ///////////////////////////////////////
        function init() {
            ctrl.totalChart = createChart([{ count: ctrl.club.totalAccounts, percentage: 100 }], totalAccountsChartDefaults);
            ctrl.levelChart = createChart(ctrl.club.levels, membershipLevelChartDefaults);
            ctrl.statusChart = createChart(ctrl.club.statuses, membershipStatusChartDefaults);
            ctrl.categoriesChart = createChart(ctrl.club.categories, categoriesChartDefaults);
            ctrl.categoriesChart.homeCounts = ctrl.club.categories.map(function (x) { return x.homeCount });
        }

        
        $scope.clickExport = function () {

            if (ctrl.club) {
                Club.getActiveRoster({
                    id: ctrl.club.id                    
                }, true).$promise.then(function (data) {
                    ctrl.downloadSource = new DataSource({
                        data: data,
                        read: getData,        
                        pageSize: data.totalCount,
                        params: {
                            id: ctrl.club.id
                        }
                    });

                    $scope.data = {};
                    $scope.data.myInputArray = data.data;
                    setTimeout(function () {
                        document.getElementById("ExportFile").click();
                    }, 1000);

                });
            }
        }
    

        function getData(options) {
            return Club.getActiveRoster(options, success, error);

            function success(data) {
                ctrl.data = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.transactionLogRequestFailed);
            }
        }

        function createChart(list, defaults) {
            var options = merge({ tooltips: { callbacks: { label: getLabel } } }, pieChartDefaultOptions);
            var result = extend({ data: list.map(map), options: options }, defaults);
            return result;

            function map(item) {
                return item.count;
            }
            function getLabel(item, data) {
                var label = gettextCatalog.getString(data.labels[item.index]),
                    value = data.datasets[item.datasetIndex].data[item.index],
                    percentage = list[item.index].percentage;
                return '{0}: {1} ({2}%)'.format(label, value, percentage.toFixed(1));
            }
        }

        function showCreditAdjustmentModal() {
            var club = ctrl.club,
                data = { id: club.id, credits: club.availableCredits, adjustment: null };

            creditAdjustmentModal(data).result.then(adjust, noop);

            function adjust(data) {
                Club.adjustMembershipCredits(data, success, error, true);
                
                function success(response) {
                    club.availableCredits = response.credits;
                }

                function error() {
                    alert.error(resources.membershipCreditAdjustmentFailed, club.name);
                }
            }
        }

        function showMembershipByCategoryModal() {
            membershipByCategoryModal(ctrl.categoriesChart);
        }

        function showCompliantClubModal() {
            compliantClubModal(ctrl.club);
        }
      
    }
})();